import { ApplicationRef, ComponentRef, createComponent, EmbeddedViewRef, EnvironmentInjector, Injectable, Injector, inject } from '@angular/core';
import { ModalRestaurantInfosComponent } from '../Components/Modal/ModalRestaurantInfos/ModalRestaurantInfos.component';

export interface ModalParameters {
  [key: string]: any;
}

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private injector = inject(Injector);
  private appRef = inject(ApplicationRef);
  private environmentInjector = inject(EnvironmentInjector);

  private modalRef: ComponentRef<any> | null = null;

  /**
   * Opens a modal dialog with the specified component
   * @param ContentComponent - The Angular component to be displayed as modal content
   * @param variables - Parameters to pass to the modal component
   * @param onEvent - Callback function to handle events emitted by the modal
   */
  open(
    ContentComponent: any,
    variables: ModalParameters,
    onEvent: Function
  ): void {
    this.close();

    const componentRef = createComponent(ContentComponent, {
      environmentInjector: this.environmentInjector,
      elementInjector: this.createInjector(variables),
    });
    if (componentRef.instance instanceof ModalRestaurantInfosComponent) {
      (
        componentRef.instance as ModalRestaurantInfosComponent
      ).messageEvent.subscribe((ev) => {
        onEvent.call(this, ev);
      });
    }

    this.appRef.attachView(componentRef.hostView);
    document.body.appendChild(
      (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0]
    );

    this.modalRef = componentRef;
  }

  /**
   * Closes the currently open modal dialog
   * Detaches the component view, removes DOM elements and destroys the component reference
   */
  close(): void {
    if (this.modalRef) {
      this.appRef.detachView(this.modalRef.hostView);
      (this.modalRef.hostView as EmbeddedViewRef<any>).rootNodes.forEach(
        (rootNode) => rootNode.remove()
      );
      this.modalRef.destroy();
      this.modalRef = null;
    }
  }

  /**
   * Creates an injector with provided variables for the modal component
   * @param variables - Object containing values to be injected into the modal component
   * @returns Injector with the provided variables
   * @private
   */
  private createInjector(variables: any): Injector {
    return Injector.create({
      providers: [{ provide: 'variables', useValue: variables }],
      parent: this.injector,
    });
  }
}
